var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "6 18 156 156",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-535.594 -20.809)",
    fill: "#32BCAD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.8 159.6c-6.5 0-12.6-2.5-17.2-7.1l-24.8-24.8c-1.7-1.7-4.8-1.7-6.5 0l-24.9 24.9c-4.6 4.6-10.7 7.1-17.2 7.1h-4.9l31.5 31.5c9.8 9.8 25.8 9.8 35.6 0l31.6-31.6h-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.1 71.8c6.5 0 12.6 2.5 17.2 7.1l24.9 24.9c1.8 1.8 4.7 1.8 6.5 0L647.6 79c4.6-4.6 10.7-7.1 17.2-7.1h3l-31.6-31.6c-9.8-9.8-25.8-9.8-35.6 0l-31.5 31.5h5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m693.9 98-19.1-19.1c-.4.2-.9.3-1.4.3h-8.7c-4.5 0-8.9 1.8-12 5L627.9 109c-2.3 2.3-5.4 3.5-8.4 3.5-3.1 0-6.1-1.2-8.4-3.5l-24.9-24.9c-3.2-3.2-7.6-5-12-5h-10.7c-.5 0-.9-.1-1.3-.3L543 98c-9.8 9.8-9.8 25.8 0 35.6l19.1 19.1c.4-.2.8-.3 1.3-.3h10.7c4.5 0 8.9-1.8 12-5l24.9-24.9c4.5-4.5 12.4-4.5 16.9 0l24.8 24.8c3.2 3.2 7.6 5 12 5h8.7c.5 0 .9.1 1.4.3l19.1-19.1c9.8-9.8 9.8-25.7 0-35.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixMark);
export default __webpack_public_path__ + "static/media/pix-mark.4bf949ec2a1b99aa1e07ccd514b6f72f.svg";
export { ForwardRef as ReactComponent };